export default __webpack_public_path__ + "static/media/exalender.32468c50.png";